// utils/exportExcel.js

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = ({
  data,
  fileName = "report",
  sheetName = "Sheet1",
}) => {
  // Prevent crash on empty data
  if (!Array.isArray(data) || data.length === 0) {
    alert("No data available to export");
    return;
  }
  const autoColumnWidths = Object.keys(data[0]).map((key) => ({
    wch: Math.max(
      key.length,
      ...data.map((row) => row[key]?.toString()?.length || 0),
    ),
  }));

  // Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  worksheet["!cols"] = autoColumnWidths;
  // Create workbook
  const workbook = XLSX.utils.book_new();

  // Append worksheet
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Generate excel buffer
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Create blob
  const fileData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  // Download
  saveAs(fileData, `${fileName}.xlsx`);
};
